import api from 'api'

const announcement = {
  namespaced: true,
  state: {
    show: false,
    announcement: null,
    viewedAnnouncements: localStorage.viewedAnnouncements ? JSON.parse(localStorage.viewedAnnouncements) : [],
  },
  getters: {
    show: (state) => state.show,
    announcement: (state) => state.announcement,
  },
  mutations: {
    setShow(state, show) {
      state.show = show
    },
    setAnnouncement(state, announcement) {
      state.announcement = announcement
    },
    setViewedAnnouncements(state, viewedAnnouncements) {
      state.viewedAnnouncements = viewedAnnouncements
      localStorage.viewedAnnouncements = JSON.stringify(viewedAnnouncements)
    },
  },
  actions: {
    show({ commit }, announcement) {
      commit('setShow', true)
      commit('setAnnouncement', announcement)
    },
    hide({ state, commit }) {
      let { viewedAnnouncements, announcement } = state
      viewedAnnouncements = [...viewedAnnouncements, announcement.id]
      commit('setViewedAnnouncements', viewedAnnouncements)
      commit('setShow', false)
      commit('setAnnouncement', null)
    },
    getAnnouncement({ state, commit }) {
      api.call('GET', '/announcement/show/', {}, (response) => {
        if (response.data && response.data.code === 0) {
          const announcement = response.data.data
          if (announcement) {
            commit('setAnnouncement', announcement)
            const { end_date } = announcement
            // 晚于 end_date 且 announcement.id 不在 viewedAnnouncements 中
            if (new Date() < new Date(end_date) && !state.viewedAnnouncements.includes(announcement.id)) {
              commit('setShow', true)
            }
          }
        }
      })
    },
  },
}

export default announcement
